import { __assign } from "tslib";
import { normalizePathname, parseAction } from 'retil-history';
import { routeRedirect } from './routeRedirect';
export function routeNormalize(router) {
    return function (request, response) {
        var pathname = normalizePathname(request.pathname);
        if (pathname === '/' || pathname === '') {
            pathname = '/';
        }
        else {
            pathname = pathname[0] !== '/' ? '/' + pathname : pathname;
            pathname =
                pathname[pathname.length - 1] === '/'
                    ? pathname.slice(0, pathname.length - 1)
                    : pathname;
        }
        if (pathname !== request.pathname) {
            return routeRedirect(parseAction(__assign(__assign({}, request), { pathname: pathname })), 301)(request, response);
        }
        return router(request, response);
    };
}
